module.exports = __webpack_public_path__ + "static/media/embed.4be95b79.png";